import get from 'lodash/get';

import type { RuntimeConfig } from '@virtuslab/nfs-shared/src/config';
import { mergeWindowConfig, getBuildTimeProcessEnv, processEnv } from '@virtuslab/nfs-shared/src/config';

const config = mergeWindowConfig(get(window, 'config', {}) as RuntimeConfig, processEnv(getBuildTimeProcessEnv(), 'User NFS'));
export default config;
